<template>
  <FormWrapper hideNavBar>
    <div class="text-center">
      <h1>🎉</h1>
      <h4 class="mt-6">
        Thank you for your interest in Elective!
      </h4>
    </div>
    <div class="my-6">
      <p>
        Our team will get back to you in the next 1-2 business days.
      </p>

      <p class="mt-4">
        Have any questions? We’re available at <HelpEmailLink />
      </p>
    </div>
    <a
      href="https://elective.com"
      class="block text-center btn btn-secondary"
    >
      Back to Elective
    </a>
  </FormWrapper>
</template>

<script setup lang="ts">
import FormWrapper from '@/components/form_wrapper.vue';
import HelpEmailLink from '@/components/help_email_link.vue';
</script>
